<template>
	<div class="login-container">
		<div class="row justify-content-center">
			<div class="login">
				<div class="login-header">
					<img src="/images/logo.svg" alt="logo" class="login-logo" />
					<img src="/images/logo-text.svg" alt="altel" />
				</div>

				<div class="login-body">
					<form @submit.prevent="login">
						<div class="row">
							<label for="email" class="login-label">Почта</label>
							<input id="email" type="email" v-model="email" class="form-control login-input login-email"
								placeholder="Введите логин" autocomplete="new-email" required />
						</div>

						<div class="row">
							<label for="password" class="login-label">Пароль</label>
							<input id="password" type="password" v-model="password"
								class="form-control login-input login-password" placeholder="Введите пароль"
								autocomplete="new-password" required />
						</div>

						<div class="row enter">
							<button type="submit" class="login-button" :disabled="loading || !email || !password">
								Войти
								<div v-if="loading" class="loader"></div>
							</button>
						</div>
					</form>

					<p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";

export default {
	name: "Login",
	data() {
		return {
			email: "",
			password: "",
			errorMessage: "", // Для отображения ошибок
			loading: false, // Индикатор загрузки
		};
	},
	methods: {
		login() {
			this.loading = true;
			this.errorMessage = "";

			if (!this.email) {
				this.loading = false;
				return;
			}
			if (!this.password) {
				this.loading = false;
				return;
			}

			axios
				.post("/login", {
					email: this.email,
					password: this.password,
				})
				.then((response) => {
					if (response.data.success) {
						this.$store.commit('setUser', response.data.user);
						this.$store.commit('setRole', response.data.role);
						window.location.href = '/campaigns';
					} else {
						this.errorMessage = response.data.message || "Неверные данные";
					}
				})
				.catch((error) => {
					this.errorMessage = "Ошибка при входе";
					this.loading = false;
				})
		},
	},
}
</script>